import React, { FC, ReactElement } from 'react';
import classNames from 'classnames/bind';
import Link from 'next/link';
import { PostType } from 'sections/Resources/BillOfLading/types';
import { Post } from 'sections/Resources/BillOfLading/components/SectionRelatedPosts/Post';
import styles from 'sections/Resources/BillOfLading/components/SectionRelatedPosts/SectionRelatedPosts.module.scss';

const cn = classNames.bind(styles);

interface SectionRelatedPostsProps {
  articles: PostType[];
};

const SectionRelatedPosts: FC<SectionRelatedPostsProps> = ({ articles }): ReactElement => {
  const posts = articles.map((article: PostType) => {
    return (
      // <li key={article.id} className="item">
      //   <Link href={`/blog/${article.url}`} className="item-link">
      //     <div className="img-box">
      //       <img
      //         className="blog-img"
      //         src={article.image}
      //         width="374"
      //         height="184"
      //         alt="Blog 1" loading="lazy" />
      //     </div>
      //     <div className="content-box">
      //       <div className="info-box">
      //         <span className="rubric">{article.tag}</span>
      //         <svg
      //           width="4"
      //           height="5"
      //           viewBox="0 0 4 5"
      //           fill="none"
      //           xmlns="http://www.w3.org/2000/svg">
      //           <circle cx="2" cy="2.74219" r="2" fill="white" />
      //         </svg>
      //         <span className="date">{processDate(article.date)}</span>
      //       </div>
      //       <p className="title">{article.title}</p>
      //     </div>
      //   </Link>
      // </li>
      <Post
        key={article.id}
        id={article.id}
        title={article.title}
        tag={article.tag}
        date={article.date}
        url={article.url}
        image={article.image}
      />
    );
  })

  return (
    <section className={cn('related-posts')}>
      <div className={cn('container')}>
        <div className={cn('related-posts__heading-box')}>
          <h2 className={cn('related-posts__heading')}>Related blogs</h2>
          <Link href="/blog" className={cn('related-posts__button-more')}>
            View all blogs
          </Link>
        </div>
        <ul className={cn('related-posts__posts')}>
          {posts}
        </ul>
      </div>
    </section>
  );
};

export default SectionRelatedPosts;